export default (tourCriteria) => {
    const tourCriteriaJson = {};
    const element = tourCriteria.get('hotelCategories');
    if (element) {
        if (element.length) {
            const hotelCategories = element.pluck('id');
            if (_.contains(hotelCategories, 7) && !_.contains(hotelCategories, 8)) {
                hotelCategories.push(8);
            }
            if (_.contains(hotelCategories, 4) && !_.contains(hotelCategories, 9)) {
                hotelCategories.push(9);
            }
            if (_.contains(hotelCategories, 2)) {
                if (!_.contains(hotelCategories, 1)) hotelCategories.push(1);
                if (!_.contains(hotelCategories, 5)) hotelCategories.push(5);
            }
            tourCriteriaJson.hotelCategories = hotelCategories;
        } else {
            tourCriteriaJson.hotelCategories = [];
        }
    }

    return tourCriteriaJson;
};